import StarRatingButton from './StarRatingButton';

export default StarRatingButton;
